// Service to handle user's feature role permissions
// This integrates with the user_feature_roles system

const API_URL = process.env.REACT_APP_API_URL || '/api';

export interface UserFeaturePermissions {
  [featureKey: string]: boolean;
}

class UserFeatureFlagService {
  // Get all feature permissions for the current user based on their assigned feature roles
  async getUserFeaturePermissions(userId: string): Promise<UserFeaturePermissions> {
    const token = localStorage.getItem('token');
    const response = await fetch(`${API_URL}/users/${userId}/feature-permissions`, {
      method: 'GET',
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
    });

    if (!response.ok) {
      throw new Error('Failed to get user feature permissions');
    }

    const result = await response.json();
    return result.data || {};
  }
}

export default new UserFeatureFlagService();